import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-arrow-right",
  "use": "foquz-icon-arrow-right-usage",
  "viewBox": "0 0 19 14",
  "content": "<symbol viewBox=\"0 0 19 14\" fill=\"none\" id=\"foquz-icon-arrow-right\"><path d=\"M.96 6.657a1 1 0 011-1h16a1 1 0 110 2h-16a1 1 0 01-1-1z\" fill=\"currentColor\" /><path d=\"M.293 7.364a1 1 0 010-1.414L5.95.293a1 1 0 111.414 1.414L1.707 7.364a1 1 0 01-1.414 0z\" fill=\"currentColor\" /><path d=\"M7.364 13.02a1 1 0 01-1.414 0L.293 7.365A1 1 0 111.707 5.95l5.657 5.657a1 1 0 010 1.414z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol